import { render, staticRenderFns } from "./BulletinCenterDetail.vue?vue&type=template&id=6eb43c6e&scoped=true&"
import script from "./BulletinCenterDetail.vue?vue&type=script&lang=js&"
export * from "./BulletinCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./BulletinCenterDetail.vue?vue&type=style&index=0&id=6eb43c6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb43c6e",
  null
  
)

export default component.exports